/**
 * @generated SignedSource<<99e19007130a48e781d620608da7152c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateContentLikeInput = {
  contentId: string;
  contentUsageId?: string | null;
  emojiAlias?: string | null;
  emojiCode?: string | null;
};
export type ContentEmojiButtonMutation$variables = {
  input: UpdateContentLikeInput;
};
export type ContentEmojiButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type ContentEmojiButtonMutation = {
  response: ContentEmojiButtonMutation$data;
  variables: ContentEmojiButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateContentLikeResponse",
    "kind": "LinkedField",
    "name": "updateContentLike",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContentLike",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentEmojiButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentEmojiButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bad1de4d11114eccc25d8fb91ee7414c",
    "id": null,
    "metadata": {},
    "name": "ContentEmojiButtonMutation",
    "operationKind": "mutation",
    "text": "mutation ContentEmojiButtonMutation(\n  $input: UpdateContentLikeInput!\n) {\n  response: updateContentLike(input: $input) {\n    node {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c763d30532fe2e55b6a963c2172f6392";

export default node;
